// extracted by mini-css-extract-plugin
export default {"tabContainer":"ComingSoonTag_tabContainer__BSQYv","tagText":"ComingSoonTag_tagText__OkqLW"};